import { createDecorator } from '../../instantiation/common/instantiation.js';
const IRemoteSocketFactoryService = ( createDecorator('remoteSocketFactoryService'));
export { IRemoteSocketFactoryService };
